<template>
	<datatable
		size="large"
		:headers
		:value="items"
		:loading
		highlight-clicked
		clickable
		expandable
		@click-row="(row) => emit('clickedItem', row)">
		<template #row-delivery_date="{ row }">
			{{ formatDate(row.delivery_date) }}
		</template>

		<template #row-physical_quantity="{ row }">
			<quantity-field
				v-if="row.stock_check_status && row.stock_check_status.length > 0"
				v-model="row.stock_check_status[0].quantity_confirmed"
				:max="row.stock_check_status[0].quantity_required"
				:disabled="row.type == 'Kit' || row.type == 'Comprises Of'"
				@update:model-value="emit('updatedItems', row)" />
		</template>

		<template #row-notes="{ row }">
			<notes-button
				v-if="row.stock_check_status?.[0]"
				:status="row.stock_check_status[0]"
				tablet
				@click="editing = row" />
		</template>
	</datatable>

	<edit-contract-item-note
		:item="editing"
		area="stock-check"
		@updated="emit('updatedNote', editing)"
		@closed="editing = null" />
</template>

<script lang="ts" setup>
	import type { Header } from '@/data/types/datatable'
	import { ref } from 'vue'
	import { formatDate } from '@/utils/date'
	import EditContractItemNote from '@/components/partials/cat2/EditContractItemNote.vue'
	import NotesButton from '@/components/partials/cat2/NotesButton.vue'
	import QuantityField from '@/components/partials/tables/QuantityField.vue'
	import type { ContractItem } from '@/data/schema/contract-item'

	const editing = ref<ContractItem | null>(null)

	defineProps({
		items: {
			type: Array<ContractItem>,
			default: []
		},
		loading: Boolean
	})

	const headers: Header[] = [
		{ value: 'item_number', text: 'Item No', props: { sortable: true, width: 150 } },
		{ value: 'description', text: 'Item Description', props: { width: 250 } },
		{ value: 'type', text: 'Type', props: { sortable: true, width: 100 } },
		{ value: 'delivery_date', text: 'Del Date', props: { sortable: true } },
		{ value: 'quantity_required', text: 'Qty Req', props: { width: 80 } },
		{ value: 'physical_quantity', text: 'Physical Qty' },
		{ value: 'notes', text: 'Notes' }
	]

	const emit = defineEmits(['updatedItems', 'updatedNote', 'clickedItem'])
</script>
